export default __webpack_public_path__ + "static/media/org_code.ef36d7f5.svg";